import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=502e48b5"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('502e48b5')) {
      api.createRecord('502e48b5', component.options)
    } else {
      api.reload('502e48b5', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=502e48b5", function () {
      api.rerender('502e48b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/Layout.vue"
export default component.exports